import React from 'react'

type SortIconVariant = 'arrow' | 'caret'

/**
 * Unified sort icon helper.
 *
 * - 'arrow' (default): shows bi-arrow-down-up when inactive, directional arrow when active.
 *   Used in <table> views (ReleasesPage, CollectionPage, etc.)
 * - 'caret': shows nothing when inactive, filled caret when active.
 *   Used in flex-table views (TrackingPage, etc.).
 */
export function getSortIcon(
  currentSort: string,
  currentOrder: 'asc' | 'desc',
  column: string,
  variant: SortIconVariant = 'arrow'
): React.ReactNode {
  if (currentSort !== column) {
    return variant === 'arrow' ? <i className="bi bi-arrow-down-up" /> : null
  }
  if (variant === 'caret') {
    return <i className={`bi bi-caret-${currentOrder === 'desc' ? 'down' : 'up'}-fill`} />
  }
  return currentOrder === 'desc'
    ? <i className="bi bi-arrow-down" />
    : <i className="bi bi-arrow-up" />
}

/** @deprecated Use getSortIcon(sort, order, column, 'arrow') */
export const getArrowSortIcon = (s: string, o: 'asc' | 'desc', c: string) => getSortIcon(s, o, c, 'arrow')

/** @deprecated Use getSortIcon(sort, order, column, 'caret') */
export const getCaretSortIcon = (s: string, o: 'asc' | 'desc', c: string) => getSortIcon(s, o, c, 'caret')
